// The report templates of a mission type are suggestions: the only one is set by default.
export const singleTemplateIdOf = <T extends string>(
  templateIds: readonly T[] | null | undefined,
): T | undefined => (templateIds?.length === 1 ? templateIds[0] : undefined);
